import { CheckEnum }                     from '@app/core/models/open-api.model';
import {
	AccountInitializationTMO,
	AccountTenantTypeEnum,
	AccountUserRoleEnum
}                                        from '@app/modules/admin-tenant/models/account.model';
import {
	SystemPropertiesTMO,
	TenantContractLogTMO,
	TenantFormBodyTMO,
	TenantGroupEnum,
	TenantInitializationTMO,
	TenantStatusEnum,
	TenantTMO,
	TenantTypeEnum
}                                        from '@app/modules/admin-tenant/models/tenant.model';
import { ArchivingFingerprintTMO }       from '@app/modules/archiving/models/archiving-common.model';
import { ArchivingErsTMO }               from '@app/modules/archiving/models/archiving-ers.model';
import {
	ArchivingExportItemStatusEnum,
	ArchivingExportItemStepEnum,
	ArchivingExportItemTMO,
	ArchivingFailureCodeEnum,
	ArchivingFailureTMO,
	ArchivingFailureTypeEnum
}                                        from '@app/modules/archiving/models/archiving-export-item.model';
import {
	ArchivingExportResultTMO,
	ArchivingExportStatusEnum,
	ArchivingExportTMO,
	ArchivingExportTypeEnum,
	CreateArchivingExportBodyTMO,
	CreateArchivingExportDateRangeTMO,
	WebhookTMO
}                                        from '@app/modules/archiving/models/archiving-export.model';
import {
	ArchivingImportStatusEnum,
	ArchivingImportTMO,
	ArchivingImportTypeEnum
}                                        from '@app/modules/archiving/models/archiving-import.model';
import {
	ArchivingCreateDocumentRequestTMO,
	ArchivingDocumentRequestMetadataTMO,
	ArchivingProceduralDocumentTMO,
	ArchivingProceduralDocumentTypeEnum
}                                        from '@app/modules/archiving/models/archiving-procedural-document.model';
import {
	ArchivingProceduralDocumentationExportResultTMO,
	ArchivingProceduralDocumentationExportStatusEnum,
	ArchivingProceduralDocumentationExportTMO,
	CreateArchivingProceduralDocumentationExportBodyTMO,
	CreateArchivingProceduralDocumentationExportValidityTMO
}                                        from '@app/modules/archiving/models/archiving-procedural-documentation-export.model';
import {
	ArchivingProceduralDocumentationRequestTMO,
	ArchivingProceduralDocumentationStatusEnum,
	ArchivingProceduralDocumentationTMO,
	ArchivingProceduralDocumentationUpdateRequestTMO,
	ArchivingProceduralDocumentationVersionTMO
}                                        from '@app/modules/archiving/models/archiving-procedural-documentation.model';
import {
	ArchivingTssLogExportDateRangeTMO,
	ArchivingTssLogExportResultTMO,
	ArchivingTssLogExportStatusEnum,
	ArchivingTssLogExportTMO,
	CreateArchivingTssLogExportBodyTMO
}                                        from '@app/modules/archiving/models/archiving-tss-log-export.model';
import {
	ArchivingTssLogCounterRangeTMO,
	ArchivingTssLogCountersTMO,
	ArchivingTssLogTMO
}                                        from '@app/modules/archiving/models/archiving-tss-log.model';
import {
	ArchivingTssStatusEnum,
	ArchivingTssTMO
}                                        from '@app/modules/archiving/models/archiving-tss.model';
import { CashPointClosingTMO }           from '@app/modules/archiving/models/cash-point-closing.model';
import {
	OpenArchiveExportResultTMO,
	OpenArchiveExportStatusEnum,
	OpenArchiveExportTMO
}                                        from '@app/modules/archiving/models/open-archive-export.model';
import {
	OpenArchiveStatusEnum,
	OpenArchiveTMO
}                                        from '@app/modules/archiving/models/open-archive.model';
import {
	StorageMetadataTMO,
	StorageTypeEnum
}                                        from '@app/modules/archiving/models/storage.model';
import {
	BusinessPremisesStatusEnum,
	BusinessPremisesTMO
}                                        from '@app/modules/business-premises/models/business-premises.model';
import {
	ClientSecretTMO,
	ClientStatusEnum,
	ClientTMO,
	CreatedClientTMO
}                                        from '@app/modules/client/models/client.model';
import {
	ArchivingSystemConfigTMO,
	ArchivingSystemPropertiesTMO,
	ConfigTypeEnum,
	DaysEnum,
	ElsterConfigTMO,
	EmailNotificationTMO,
	EricConfigTMO,
	NotificationConfigTMO,
	SchedulingConfigTMO,
	SchedulingStatusEnum,
	SystemConfigBodyTMO,
	SystemConfigTMO,
	TssConfigTMO
}                                        from '@app/modules/configuration/models/configuration.model';
import {
	ArchivingAllContractPropertiesLogTMO,
	ArchivingContractTMO,
	ArchivingContractTypeEnum,
	ArchivingTenantContractTypeTMO,
	ContractFormTMO,
	ContractLogPeriodEnum,
	ContractStatusEnum,
	ContractTypeGroupEnum,
	ElsterAllContractPropertiesLogTMO,
	ElsterContractTMO,
	FiskalAllContractPropertiesLogTMO,
	FiskalContractTMO
}                                        from '@app/modules/contract/models/contract.model';
import {
	TenantTransactionStatisticsTMO,
	TransactionOperationCountTMO,
	TransactionStatisticsTMO,
	TransactionStatisticsTypeDetailTMO,
	TransactionStatisticsTypeTMO
}                                        from '@app/modules/dashboard/model/transaction.model';
import {
	EncryptionKeyBodyTMO,
	EncryptionKeyExportTMO,
	EncryptionKeyStatusEnum,
	EncryptionKeyTMO,
	KeyAlgorithmEnum,
	KeyScopeEnum
}                                        from '@app/modules/encryption-key/models/encryption-key.model';
import {
	ErsDeviceTypeEnum,
	ErsExternalStatusEnum,
	ErsExternalTMO,
	ErsReportStateEnum,
	ErsStatusEnum,
	ErsStatusStatisticsTMO,
	ErsTMO
}                                        from '@app/modules/ers/models/ers.model';
import {
	FccVersionBodyTMO,
	FccVersionStatusEnum,
	FccVersionTMO,
	FccVersionTssModeStatusTMO
}                                        from '@app/modules/fcc-version/models/fcc-version.model';
import {
	FccDataCenterStatusEnum,
	FccDatacenterTMO
}                                        from '@app/modules/fcc/fcc-datacenter/models/fcc-datacenter.model';
import {
	FccOpenTransactionInfoCounterTMO,
	FccOpenTransactionsInfoCountItemTMO,
	FccOpenTransactionsInfoCountsTMO
}                                        from '@app/modules/fcc/fcc-open-transaction/models/fcc-open-transaction.model';
import { FccInstallationTypeEnum }       from '@app/modules/fcc/models/fcc.model';
import {
	BusinessPremisesLogInfoTMO,
	FiskalDownloadInfo,
	FiskalEncryptionInfoEncryptionAgentTMO,
	FiskalEncryptionInfoTMO,
	FiskalEncryptionInfoWrappedContentKeyTMO,
	FiskalExportStatusEnum,
	FiskalLogFileInfoTMO,
	FiskalTssLogMetadataSummaryTMO,
	FiskalTssLogMetadataTMO
}                                        from '@app/modules/fiskal-tss-log/models/fiskal-tss-log.model';
import { ArchivingKeywordTMO }           from '@app/modules/keyword/models/archiving-keyword.model';
import {
	NotificationAdminTMO,
	NotificationTargetTypeEnum,
	NotificationTMO
}                                        from '@app/modules/notification/models/notification.model';
import {
	LegalFormEnum,
	OrganizationStatusEnum,
	OrganizationTMO
}                                        from '@app/modules/organization/models/organization.model';
import {
	OutageEventBodyTMO,
	OutageEventStatusEnum,
	OutageEventTMO,
	TaskOutageBusinessPremisesCountTMO
}                                        from '@app/modules/outage/models/outage.model';
import {
	ExportFileTypeEnum,
	ExportSetModeEnum,
	ExportSetStatusEnum,
	ExportSetTMO,
	ExportSetTypeEnum
}                                        from '@app/modules/structure-export/models/structure-export.model';
import {
	CsvFileEncodingEnum,
	ImportFileTypeEnum,
	ImportModeEnum,
	ImportSetStatusEnum,
	ImportTMO,
	ImportTypeEnum
}                                        from '@app/modules/structure-import/models/structure-import.model';
import {
	TaxationReportingFailuresTMO,
	TaxationReportingFormTypeEnum,
	TaxationReportingMandateConfirmTMO,
	TaxationReportingStatusEnum,
	TaxationReportingTMO
}                                        from '@app/modules/taxation/taxation-reporting/models/taxation-reporting.model';
import {
	TssPreInitializationModeEnum,
	TssPreInitializationRequestTMO,
	TssPreInitializationStatusEnum,
	TssPreInitializationTMO
}                                        from '@app/modules/tss-pre-initialization/models/tss-pre-initialization.model';
import { CspStatus }                     from '@app/modules/tss/models/csp.model';
import {
	TssAssignmentTypeEnum,
	TssBodyTMO,
	TssDeviceTypeEnum,
	TssExternalStatusEnum,
	TssExternalTMO,
	TssFccVersionsCountTMO,
	TssFccVersionsModeCountTMO,
	TssFccVersionsSubtypeModeCountTMO,
	TssFccVersionsTMO,
	TssModeEnum,
	TssModeStatisticsTMO,
	TssModeSubTypeEnum,
	TssModeWithSubTypeEnum,
	TssRequestTMO,
	TssStatusEnum,
	TssStatusStatisticsTMO,
	TssTMO
}                                        from '@app/modules/tss/models/tss.model';
import {
	ArchivingContractDataUsageTMO,
	ArchivingContractUsageTMO,
	ArchivingDataUsageDetailTMO,
	ArchivingDataUsageTMO,
	ArchivingTenantDataUsageTMO,
	ArchivingUsageErsActivatedPerMonthTMO,
	ArchivingUsageErsPriceTMO,
	ArchivingUsageTMO
}                                        from '@app/modules/usage/models/archiving-usage.model';
import {
	BusinessPremisesUsageTMO,
	ContractUsageTenantsTMO,
	ErsUsageItemTMO,
	ErsUsageTMO,
	OrganizationUsageTMO,
	TenantUsageTMO,
	TssUsageItemTMO,
	TssUsageTMO,
	UsageItemFullTypeEnum,
	UsageItemTMO,
	UsageTMO
}                                        from '@app/modules/usage/models/fiskal-usage.model';
import {
	ReportStatusEnum,
	ReportStatusTMO
}                                        from '@app/modules/usage/models/usage-report.model';
import {
	RealmEnum,
	UserChangePassTMO,
	UserCreateBodyTMO,
	UserStatusBodyTMO,
	UserStatusEnum,
	UserTMO,
	UserUpdateBodyTMO
}                                        from '@app/modules/user/models/user.model';
import { ManagedObjectTMO }              from '@app/shared/models/managed-object.model';
import {
	IDtoTmoModelMapType,
	ObjectTypeEnum
}                                        from '@core/interfaces/open-api.interface';
import { SalutationEnum }                from '@models/common.model';
import { LanguageEnum }                  from '@models/language';
import {
	ResourceLockTMO,
	ResourceLockTypeEnum
}                                        from '@models/resource-lock.model';
import {
	ClsCashPointClosingDTO,
	ClsErsDTO as ArchivingClsErsDTO,
	ClsFingerprintDTO as ClsArchivingFingerprintDTO,
	ClsImportDTO,
	ClsImportStatusEnumDTO,
	ClsImportTypeEnumDTO,
	ClsKeywordDTO,
	ClsOpenArchiveDTO,
	ClsOpenArchiveStatusDTO,
	ClsPDDocumentDTO,
	ClsPDDocumentRequestDTO,
	ClsPDDocumentRequestMetadataDTO,
	ClsPDDocumentTypeDTO,
	ClsProceduralDocumentationBodyDTO,
	ClsProceduralDocumentationDTO,
	ClsProceduralDocumentationRequestDTO,
	ClsProceduralDocumentationStatusDTO,
	ClsProceduralDocumentationVersionDTO,
	ClsRangeDTO,
	ClsStorageMetadataDTO,
	ClsStorageTypeEnumDTO,
	ClsTssLogCountersDTO,
	ClsTssLogDTO,
	ClsVirtualTssDTO as ClsArchiveTssDTO,
	ClsVirtualTssStatusEnumDTO as ClsArchiveTssStatusEnumDTO
}                                        from '@openApi/generated/archiving-api';
import {
	ClsAdminArchivingSystemConfigBodyDTO,
	ClsAdminSystemConfigurationBodyDTO,
	ClsContractCreateBodyDTO,
	ClsContractDTO,
	ClsContractLogPeriodEnumDTO,
	ClsContractPropertiesLogDTO,
	ClsContractTypeGroupEnumDTO,
	ClsElsterConfigurationDTO,
	ClsInitializationDTO,
	ClsLegalFormEnumDTO,
	ClsSystemConfigurationDTO as ClsAdminSystemConfigurationDTO,
	ClsTenantBodyDTO,
	ClsTenantGroupEnumDTO,
	ClsTenantStatusEnumDTO,
	ClsTenantTypeEnumDTO
}                                        from '@openApiGenerated/admin-api';
import {
	ClsCashPointClosingBusinessDateRangeDTO,
	ClsCreateExportBodyDTO,
	ClsCreateProceduralDocumentationExportBodyDTO,
	ClsCreateTssLogExportsBodyDTO,
	ClsExportDTO,
	ClsExportItemDTO,
	ClsExportItemStatusEnumDTO,
	ClsExportItemStepEnumDTO,
	ClsExportResultDTO,
	ClsExportStatusEnumDTO,
	ClsExportTypeEnumDTO,
	ClsFailureDTO,
	ClsFailureDTOCodeEnum,
	ClsFailureDTOTypeEnum,
	ClsOpenArchiveExportDTO,
	ClsProceduralDocumentationExportDTO,
	ClsProceduralDocumentationValidityDTO,
	ClsTssLogBusinessDateRangeDTO,
	ClsTssLogExportDTO,
	ClsWebhookDTO
}                                        from '@openApiGenerated/archiving-export-api';
import {
	ClsAdminArchivingContractBodyDTO,
	ClsArchivingContractDTO,
	ClsArchivingContractPropertiesLogDTO,
	ClsContractLogPeriodEnumDTO as ClsArchivingContractLogPeriodEnumDTO,
	ClsContractStatusEnumDTO as ClsArchivingContractStatusEnumDTO,
	ClsContractTypeEnumDTO as ClsArchivingContractTypeEnumDTO
}                                        from '@openApiGenerated/archiving-usage-admin-api';
import {
	ClsArchivingTenantContractTypeResponseDTO,
	ClsContractDataUsageResponseDTO,
	ClsContractUsageResponseDTO,
	ClsCustomerErsUsageDTO,
	ClsDataUsageDetailDTO,
	ClsDataUsageDTO,
	ClsErsActivatedPerMonthDTO,
	ClsErsPriceDTO,
	ClsTenantDataUsageDTO
}                                        from '@openApiGenerated/archiving-usage-api';
import {
	ClsArchiveUserDTO,
	ClsArchiveUserSecretDTO,
	ClsArchiveUserStatusDTO,
	ClsCreatedArchiveUserDTO
}                                        from '@openApiGenerated/archiving-user-management-api';
import {
	ClsBusinessPremisesDTO as ClsBusinessPremisesCountDTO,
	ClsEventReasonBodyDTO,
	ClsEventStatusEnumDTO,
	ClsOutageEventDTO
}                                        from '@openApiGenerated/audit-event-api';
import {
	ClsAdminElsterContractBodyDTO,
	ClsEricConfigurationDTO
}                                        from '@openApiGenerated/eric-wrapper-admin-api';
import {
	ClsContractStatusEnumDTO as ClsElsterContractStatusEnumDTO,
	ClsElsterContractDTO,
	ClsElsterContractPropertiesLogDTO,
	ClsFailureDTO as ClsRegistrationProtocolFailuresDTO,
	ClsFormTypeEnumDTO,
	ClsMandateConfirmDTO,
	ClsRegistrationProtocolDTO,
	ClsRegistrationProtocolStatusEnumDTO,
	RegistrationProtocolStatusEnumDTO
}                                        from '@openApiGenerated/eric-wrapper-api';
import {
	ClsExportModeDTO,
	ClsExportSetDTO,
	ClsExportSetDTOExportTypeEnum,
	ClsExportSetStatusDTO,
	ClsFileTypeDTO as StructureExportClsFileTypeDTO
}                                        from '@openApiGenerated/export-api';
import { ClsTenantTssConfigResponseDTO } from '@openApiGenerated/fiskal-tss-log-admin-api';
import {
	ClsBusinessPremisesLogInfoDTO,
	ClsDownloadInfoDTO,
	ClsEncryptionInfoDTO,
	ClsEncryptionInfoEncryptionAgentDTO,
	ClsEncryptionInfoWrappedContentKeyDTO,
	ClsExportStatusDTO,
	ClsLogFileInfoDTO,
	ClsMetaDataDTO,
	ClsMetaDataSummaryDTO
}                                        from '@openApiGenerated/fiskal-tss-log-export-api';
import {
	ClsCsvFileEncodingDTO,
	ClsFileTypeDTO as StructureImportClsFileTypeDTO,
	ClsImportModeDTO,
	ClsImportSetDTO,
	ClsImportSetDTOImportTypeEnum,
	ClsImportSetStatusDTO,
	ImportSetDTOImportTypeEnum
}                                        from '@openApiGenerated/import-api';
import {
	ClsAccountInitializationDTO,
	ClsAccountTenantTypeEnumDTO,
	ClsAccountUserRoleEnumDTO,
	ClsArchivingSystemPropertiesDTO,
	ClsAssignmentTypeEnumDTO,
	ClsBusinessPremisesDTO,
	ClsBusinessPremisesStatusEnumDTO,
	ClsConfigTypeDTO,
	ClsContractLogDTO,
	ClsContractStatusEnumDTO,
	ClsCspAccountStatusEnumDTO,
	ClsDaysEnumDTO,
	ClsEmailNotificationDTO,
	ClsEmailNotificationDTOLanguageEnum,
	ClsEncryptionKeyBodyDTO,
	ClsEncryptionKeyDTO,
	ClsEncryptionKeyExportResponseDTO,
	ClsEncryptionKeyStatusEnumDTO,
	ClsEntityReportStateEnumDTO,
	ClsErsDeviceTypeEnumDTO,
	ClsErsDTO,
	ClsErsStatusEnumDTO,
	ClsExtErsDTO,
	ClsExtErsStatusEnumDTO,
	ClsExtVirtualTssDTO,
	ClsExtVirtualTssStatusEnumDTO,
	ClsFccDataCenterDTO,
	ClsFccDataCenterInstallationStatusEnumDTO,
	ClsFccInstallationTypeEnumDTO,
	ClsFccOpenTransactionsCountDTO,
	ClsFccOpenTransactionsCountResultsDTO,
	ClsFccVersionBodyDTO,
	ClsFccVersionDTO,
	ClsFccVersionStatusEnumDTO,
	ClsFccVersionTssModeStatusDTO,
	ClsKeyAlgorithmEnumDTO,
	ClsKeyScopeEnumDTO,
	ClsModeCountDTO,
	ClsNaturalPersonDTO,
	ClsNotificationConfigurationDTO,
	ClsOpenTransactionCounterAllOfDTO,
	ClsOrganizationDTO,
	ClsOrganizationStatusEnumDTO,
	ClsResourceLockDTO,
	ClsResourceLockTypeEnumDTO,
	ClsSalutationEnumDTO,
	ClsSchedulingConfigurationDTO,
	ClsSchedulingStatusEnumDTO,
	ClsSubtypeModeCountDTO,
	ClsSystemConfigurationBodyDTO,
	ClsSystemConfigurationDTO,
	ClsSystemPropertiesDTO,
	ClsTenantDTO,
	ClsVirtualTssBodyDTO,
	ClsVirtualTssDeviceTypeEnumDTO,
	ClsVirtualTssDTO,
	ClsVirtualTssModeEnumDTO,
	ClsVirtualTssModeSubtypeEnumDTO,
	ClsVirtualTssModeWithSubtypeEnumDTO,
	ClsVirtualTssPerFccVersionCountDTO,
	ClsVirtualTssRequestDTO,
	ClsVirtualTssStatusEnumDTO,
	ClsVirtualTssVersionsCountResponseDTO,
	VirtualTssDeviceTypeEnumDTO
}                                        from '@openApiGenerated/management-api';
import {
	ClsAdminNotificationDTO,
	ClsTargetTypeDTO as ClsNotificationTargetTypeDTO
}                                        from '@openApiGenerated/notification-admin-api';
import { ClsNotificationDTO }            from '@openApiGenerated/notification-api';
import {
	ClsTssPreInitializationDTO,
	ClsTssPreInitializationModeDTO,
	ClsTssPreInitializationRequestDTO,
	ClsTssPreInitializationStatusDTO
}                                        from '@openApiGenerated/selfcare-api';
import {
	ClsEnvironmentEnumDTO,
	ClsErsStatusStatisticsDTO as ClsErsStatusGlobalStatisticsDTO,
	ClsGlobalStatisticsDTO,
	ClsGlobalStatisticsResponseDTO,
	ClsTenantStatisticsDTO,
	ClsTenantTransactionStatisticsResponseDTO,
	ClsTenantTypeCountStatisticsDTO,
	ClsTenantTypeEnumDTO as ClsGlobalStatisticTenantTypeEnumDTO,
	ClsTransactionOperationCountDTO,
	ClsTransactionStatisticsDTO,
	ClsTransactionStatisticsTypeDetailDTO,
	ClsTransactionStatisticsTypeDTO,
	ClsTssModeStatisticsDTO as ClsTssModeGlobalStatisticsDTO,
	ClsTssStatusStatisticsDTO as ClsTssStatusGlobalStatisticsDTO
}                                        from '@openApiGenerated/statistics-api';
import {
	ClsBusinessPremisesUsageContractDTO,
	ClsCustomerUsageContractDTO,
	ClsErsUsageDTO,
	ClsErsUsageItemDTO,
	ClsOrganizationUsageContractDTO,
	ClsReportStatusDTO,
	ClsReportStatusEnumDTO,
	ClsTenantUsageContractDTO,
	ClsUsageDTO,
	ClsUsageItemDTO,
	ClsUsageTypeEnumDTO,
	ClsVirtualTssUsageDTO,
	ClsVirtualTssUsageItemDTO
}                                        from '@openApiGenerated/usage-api';
import {
	ClsCreateUserBodyDTO,
	ClsManagedObjectDTO,
	ClsRealmDTO,
	ClsUserBodyDTO,
	ClsUserDTO,
	ClsUserPasswordChangeBodyDTO,
	ClsUserStatusBodyDTO,
	ClsUserStatusDTO
}                                        from '@openApiGenerated/user-management-api';
import { NaturalPersonTMO }              from '@shared/models/natural-person.model';
import {
	GlobalStatisticEnvironmentEnum,
	GlobalStatisticsTMO,
	GlobalStatisticTMO,
	TenantStatisticsTMO,
	TenantTypeCountStatisticsTMO
}                                        from '@shared/overview/statistics.model';


export interface IOpenApiConfig {
	dtoClassPrefix: string;

	apiClassPrefix: string;

	dtoCheckList: IDtoTmoModelMapType[];
}


export const OPENAPI_CONFIG: IOpenApiConfig = {
	dtoClassPrefix: 'Cls',
	apiClassPrefix: 'ApiCls',
	dtoCheckList: [
		// AdminTenant
		// models
		{ dto: new ClsInitializationDTO(), tmo: new TenantInitializationTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsAccountInitializationDTO(), tmo: new AccountInitializationTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsTenantGroupEnumDTO(),
			tmo: TenantGroupEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'TenantGroupEnum'
		},
		{
			dto: new ClsTenantStatusEnumDTO(),
			tmo: TenantStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'TenantStatusEnum'
		},
		{ dto: new ClsTenantTypeEnumDTO(), tmo: TenantTypeEnum, checkList: [ CheckEnum.ENUM_CHECK_ALL ], type: ObjectTypeEnum.ENUM, tmoEnumName: 'TenantTypeEnum' },
		{
			dto: new ClsAccountTenantTypeEnumDTO(),
			tmo: AccountTenantTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'AccountTenantTypeEnum'
		},
		{
			dto: new ClsAccountUserRoleEnumDTO(),
			tmo: AccountUserRoleEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'AccountUserRoleEnum'
		},

		// Archiving
		// models
		{ dto: new ClsImportDTO(), tmo: new ArchivingImportTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsStorageMetadataDTO(), tmo: new StorageMetadataTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsArchivingFingerprintDTO(), tmo: new ArchivingFingerprintTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsCashPointClosingDTO(), tmo: new CashPointClosingTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ArchivingClsErsDTO(), tmo: new ArchivingErsTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsExportDTO(), tmo: new ArchivingExportTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsExportResultDTO(), tmo: new ArchivingExportResultTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsCreateExportBodyDTO(), tmo: new CreateArchivingExportBodyTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{
			dto: new ClsCashPointClosingBusinessDateRangeDTO(),
			tmo: new CreateArchivingExportDateRangeTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{ dto: new ClsWebhookDTO(), tmo: new WebhookTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsExportItemDTO(), tmo: new ArchivingExportItemTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsFailureDTO(), tmo: new ArchivingFailureTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsImportTypeEnumDTO(),
			tmo: ArchivingImportTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ArchivingImportTypeEnum'
		},
		{
			dto: new ClsImportStatusEnumDTO(),
			tmo: ArchivingImportStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ArchivingImportStatusEnum'
		},
		{
			dto: new ClsExportStatusEnumDTO(),
			tmo: ArchivingExportStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ArchivingExportStatusEnum'
		},
		{
			dto: new ClsExportTypeEnumDTO(),
			tmo: ArchivingExportTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ArchivingExportTypeEnum'
		},
		{
			dto: new ClsExportItemStepEnumDTO(),
			tmo: ArchivingExportItemStepEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ArchivingExportItemStepEnum'
		},
		{
			dto: new ClsExportItemStatusEnumDTO(),
			tmo: ArchivingExportItemStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ArchivingExportItemStatusEnum'
		},
		{
			dto: new ClsFailureDTOTypeEnum(),
			tmo: ArchivingFailureTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ArchivingFailureTypeEnum'
		},
		{
			dto: new ClsFailureDTOCodeEnum(),
			tmo: ArchivingFailureCodeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ArchivingFailureCodeEnum'
		},
		{
			dto: new ClsStorageTypeEnumDTO(),
			tmo: StorageTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'StorageTypeEnum'
		},

		// Archiving Tss log
		// models
		{ dto: new ClsTssLogDTO(), tmo: new ArchivingTssLogTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsTssLogExportDTO(), tmo: new ArchivingTssLogExportTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsExportResultDTO(), tmo: new ArchivingTssLogExportResultTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{
			dto: new ClsCreateTssLogExportsBodyDTO(),
			tmo: new CreateArchivingTssLogExportBodyTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{
			dto: new ClsTssLogBusinessDateRangeDTO(),
			tmo: new ArchivingTssLogExportDateRangeTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{ dto: new ClsTssLogCountersDTO(), tmo: new ArchivingTssLogCountersTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsRangeDTO(), tmo: new ArchivingTssLogCounterRangeTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsExportStatusEnumDTO(),
			tmo: ArchivingTssLogExportStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			tmoEnumName: 'ArchivingTssLogExportStatusEnum',
			type: ObjectTypeEnum.ENUM
		},

		// Archiving Tss
		// models
		{ dto: new ClsArchiveTssDTO(), tmo: new ArchivingTssTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsArchiveTssStatusEnumDTO(),
			tmo: ArchivingTssStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ArchivingTssStatusEnum'
		},

		// Archiving Procedural Documentation
		// models
		{
			dto: new ClsProceduralDocumentationDTO(),
			tmo: new ArchivingProceduralDocumentationTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{
			dto: new ClsProceduralDocumentationVersionDTO(),
			tmo: new ArchivingProceduralDocumentationVersionTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{
			dto: new ClsProceduralDocumentationRequestDTO(),
			tmo: new ArchivingProceduralDocumentationRequestTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{
			dto: new ClsProceduralDocumentationBodyDTO(),
			tmo: new ArchivingProceduralDocumentationUpdateRequestTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		// enums
		{
			dto: new ClsProceduralDocumentationStatusDTO(),
			tmo: ArchivingProceduralDocumentationStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ArchivingProceduralDocumentationStatusEnum'
		},

		// Archiving Procedural Document
		// models
		{ dto: new ClsPDDocumentDTO(), tmo: new ArchivingProceduralDocumentTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsArchivingFingerprintDTO(), tmo: new ArchivingFingerprintTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsPDDocumentRequestDTO(), tmo: new ArchivingCreateDocumentRequestTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{
			dto: new ClsPDDocumentRequestMetadataDTO(),
			tmo: new ArchivingDocumentRequestMetadataTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		// enums
		{
			dto: new ClsPDDocumentTypeDTO(),
			tmo: ArchivingProceduralDocumentTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ArchivingProceduralDocumentTypeEnum'
		},

		// Archiving Procedural Documentation Export
		// models
		{
			dto: new ClsProceduralDocumentationExportDTO(),
			tmo: new ArchivingProceduralDocumentationExportTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{
			dto: new ClsExportResultDTO(),
			tmo: new ArchivingProceduralDocumentationExportResultTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{
			dto: new ClsCreateProceduralDocumentationExportBodyDTO(),
			tmo: new CreateArchivingProceduralDocumentationExportBodyTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{
			dto: new ClsProceduralDocumentationValidityDTO(),
			tmo: new CreateArchivingProceduralDocumentationExportValidityTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		// enums
		{
			dto: new ClsExportStatusEnumDTO(),
			tmo: ArchivingProceduralDocumentationExportStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ArchivingProceduralDocumentationExportStatusEnum'
		},

		// Business Premises
		// models
		{ dto: new ClsBusinessPremisesDTO(), tmo: new BusinessPremisesTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsBusinessPremisesStatusEnumDTO(),
			tmo: BusinessPremisesStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'BusinessPremisesStatusEnum'
		},

		// Client
		{ dto: new ClsArchiveUserDTO(), tmo: new ClientTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsCreatedArchiveUserDTO(), tmo: new CreatedClientTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsArchiveUserSecretDTO(), tmo: new ClientSecretTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsArchiveUserStatusDTO(),
			tmo: ClientStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ClientStatusEnum'
		},

		// Contract
		// archive
		{ dto: new ClsArchivingContractDTO(), tmo: new ArchivingContractTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{
			dto: new ClsArchivingContractPropertiesLogDTO(),
			tmo: new ArchivingAllContractPropertiesLogTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{
			dto: new ClsArchivingTenantContractTypeResponseDTO(),
			tmo: new ArchivingTenantContractTypeTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{ dto: new ClsAdminArchivingContractBodyDTO(), tmo: new ContractFormTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsArchivingContractStatusEnumDTO(),
			tmo: ContractStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			excludeTmoPropsFromCheckList: [ ContractStatusEnum.DELETED ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ContractStatusEnum'
		},
		{
			dto: new ClsArchivingContractLogPeriodEnumDTO(),
			tmo: ContractLogPeriodEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ContractLogPeriodEnum'
		},
		{
			dto: new ClsArchivingContractTypeEnumDTO(),
			tmo: ArchivingContractTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ArchivingContractTypeEnum'
		},

		// elster
		{ dto: new ClsElsterContractDTO(), tmo: new ElsterContractTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{
			dto: new ClsElsterContractPropertiesLogDTO(),
			tmo: new ElsterAllContractPropertiesLogTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{ dto: new ClsAdminElsterContractBodyDTO(), tmo: new ContractFormTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsElsterContractStatusEnumDTO(),
			tmo: ContractStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			excludeTmoPropsFromCheckList: [ ContractStatusEnum.DELETED ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ContractStatusEnum'
		},

		// fiskal
		{ dto: new ClsContractDTO(), tmo: new FiskalContractTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{
			dto: new ClsContractPropertiesLogDTO(),
			tmo: new FiskalAllContractPropertiesLogTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{ dto: new ClsContractCreateBodyDTO(), tmo: new ContractFormTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsContractTypeGroupEnumDTO(),
			tmo: ContractTypeGroupEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ContractTypeGroupEnum'
		},
		{
			dto: new ClsContractStatusEnumDTO(),
			tmo: ContractStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			excludeTmoPropsFromCheckList: [ ContractStatusEnum.DELETED ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ContractStatusEnum'
		},
		{
			dto: new ClsContractLogPeriodEnumDTO(),
			tmo: ContractLogPeriodEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ContractLogPeriodEnum'
		},

		// CSP
		// enums
		{ dto: new ClsCspAccountStatusEnumDTO(), tmo: CspStatus, checkList: [ CheckEnum.ENUM_CHECK_ALL ], type: ObjectTypeEnum.ENUM, tmoEnumName: 'CspStatus' },


		// ElsterConfiguration (Tenant/Business Premises)
		// models
		{ dto: new ClsElsterConfigurationDTO(), tmo: new ElsterConfigTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsEricConfigurationDTO(), tmo: new EricConfigTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums

		// SchedulingConfiguration (Tenant/Business Premises)
		// models
		{ dto: new ClsSchedulingConfigurationDTO(), tmo: new SchedulingConfigTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsSchedulingStatusEnumDTO(),
			tmo: SchedulingStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'SchedulingStatusEnum'
		},
		{ dto: new ClsDaysEnumDTO(), tmo: DaysEnum, checkList: [ CheckEnum.ENUM_CHECK_ALL ], type: ObjectTypeEnum.ENUM, tmoEnumName: 'DaysEnum' },
		{ dto: new ClsConfigTypeDTO(), tmo: ConfigTypeEnum, checkList: [ CheckEnum.ENUM_CHECK_ALL ], type: ObjectTypeEnum.ENUM, tmoEnumName: 'ConfigTypeEnum' },

		// TssLogNotificationConfiguration (Tenant/Business Premises)
		// models
		{ dto: new ClsNotificationConfigurationDTO(), tmo: new NotificationConfigTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsEmailNotificationDTO(), tmo: new EmailNotificationTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsEmailNotificationDTOLanguageEnum(),
			tmo: LanguageEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'LanguageEnum'
		},

		// SystemConfiguration (Tenant/Business Premises)
		// models
		{ dto: new ClsAdminSystemConfigurationDTO(), tmo: new SystemConfigTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{
			dto: new ClsAdminArchivingSystemConfigBodyDTO(),
			tmo: new ArchivingSystemConfigTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{ dto: new ClsAdminSystemConfigurationBodyDTO(), tmo: new SystemConfigBodyTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsSystemConfigurationDTO(), tmo: new SystemConfigTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsSystemConfigurationBodyDTO(), tmo: new SystemConfigBodyTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{ dto: new ClsConfigTypeDTO(), tmo: ConfigTypeEnum, checkList: [ CheckEnum.ENUM_CHECK_ALL ], type: ObjectTypeEnum.ENUM, tmoEnumName: 'ConfigTypeEnum' },

		// SystemProperties
		// models
		{ dto: new ClsSystemPropertiesDTO(), tmo: new SystemPropertiesTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{
			dto: new ClsArchivingSystemPropertiesDTO(),
			tmo: new ArchivingSystemPropertiesTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		// enums

		// EncryptionKey
		// models
		{ dto: new ClsEncryptionKeyDTO(), tmo: new EncryptionKeyTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsEncryptionKeyBodyDTO(), tmo: new EncryptionKeyBodyTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsEncryptionKeyExportResponseDTO(), tmo: new EncryptionKeyExportTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsEncryptionKeyStatusEnumDTO(),
			tmo: EncryptionKeyStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'EncryptionKeyStatusEnum'
		},
		{ dto: new ClsKeyScopeEnumDTO(), tmo: KeyScopeEnum, checkList: [ CheckEnum.ENUM_CHECK_ALL ], type: ObjectTypeEnum.ENUM, tmoEnumName: 'KeyScopeEnum' },
		{
			dto: new ClsKeyAlgorithmEnumDTO(),
			tmo: KeyAlgorithmEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'KeyAlgorithmEnum'
		},

		// Ers
		// models
		{ dto: new ClsErsDTO(), tmo: new ErsTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsExtErsDTO(), tmo: new ErsExternalTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsErsStatusGlobalStatisticsDTO(), tmo: new ErsStatusStatisticsTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsErsDeviceTypeEnumDTO(),
			tmo: ErsDeviceTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ErsDeviceTypeEnum'
		},
		{ dto: new ClsErsStatusEnumDTO(), tmo: ErsStatusEnum, checkList: [ CheckEnum.ENUM_CHECK_ALL ], type: ObjectTypeEnum.ENUM, tmoEnumName: 'ErsStatusEnum' },
		{
			dto: new ClsExtErsStatusEnumDTO(),
			tmo: ErsExternalStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ErsExternalStatusEnum'
		},
		{
			dto: new ClsEntityReportStateEnumDTO(),
			tmo: ErsReportStateEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ErsReportStateEnum'
		},

		// FCC
		// models
		{ dto: new ClsFccDataCenterDTO(), tmo: new FccDatacenterTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsFccDataCenterInstallationStatusEnumDTO(),
			tmo: FccDataCenterStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'FccDataCenterStatusEnum'
		},
		{
			dto: new ClsFccInstallationTypeEnumDTO(),
			tmo: FccInstallationTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'FccInstallationTypeEnum'
		},

		// FCC OpenTransactions
		// models
		{
			dto: new ClsFccOpenTransactionsCountResultsDTO(),
			tmo: new FccOpenTransactionsInfoCountsTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{
			dto: new ClsFccOpenTransactionsCountDTO(),
			tmo: new FccOpenTransactionsInfoCountItemTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{
			dto: new ClsOpenTransactionCounterAllOfDTO(),
			tmo: new FccOpenTransactionInfoCounterTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		// enums


		// FCC version
		// models
		{ dto: new ClsFccVersionDTO(), tmo: new FccVersionTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsFccVersionTssModeStatusDTO(), tmo: new FccVersionTssModeStatusTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsFccVersionBodyDTO(), tmo: new FccVersionBodyTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsFccVersionStatusEnumDTO(),
			tmo: FccVersionStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'FccVersionStatusEnum'
		},
		// FiskalTssConfig
		// models
		{ dto: new ClsTenantTssConfigResponseDTO(), tmo: new TssConfigTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums

		// FiskalTssLog
		// models
		{ dto: new ClsMetaDataDTO(), tmo: new FiskalTssLogMetadataTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsMetaDataSummaryDTO(), tmo: new FiskalTssLogMetadataSummaryTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsDownloadInfoDTO(), tmo: new FiskalDownloadInfo(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsEncryptionInfoDTO(), tmo: new FiskalEncryptionInfoTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{
			dto: new ClsEncryptionInfoEncryptionAgentDTO(),
			tmo: new FiskalEncryptionInfoEncryptionAgentTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{
			dto: new ClsEncryptionInfoWrappedContentKeyDTO(),
			tmo: new FiskalEncryptionInfoWrappedContentKeyTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{ dto: new ClsLogFileInfoDTO(), tmo: new FiskalLogFileInfoTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsBusinessPremisesLogInfoDTO(), tmo: new BusinessPremisesLogInfoTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsExportStatusDTO(),
			tmo: FiskalExportStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'FiskalExportStatusEnum'
		},

		// Structure Import
		// models
		{ dto: new ClsImportSetDTO(), tmo: new ImportTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsImportSetDTOImportTypeEnum(),
			tmo: ImportTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			excludeDtoPropsFromCheckList: [ ImportSetDTOImportTypeEnum.EXT_ERS, ImportSetDTOImportTypeEnum.EXT_TSS ],
			excludeTmoPropsFromCheckList: [ ImportTypeEnum.ERS_EXTERNAL, ImportTypeEnum.TSS_EXTERNAL ],
			tmoEnumName: 'ImportTypeEnum'
		},
		{
			dto: new ClsImportSetStatusDTO(),
			tmo: ImportSetStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ImportSetStatusEnum'
		},
		{
			dto: new StructureImportClsFileTypeDTO(),
			tmo: ImportFileTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ImportFileTypeEnum'
		},
		{ dto: new ClsImportModeDTO(), tmo: ImportModeEnum, checkList: [ CheckEnum.ENUM_CHECK_ALL ], type: ObjectTypeEnum.ENUM, tmoEnumName: 'ImportModeEnum' },
		{
			dto: new ClsCsvFileEncodingDTO(),
			tmo: CsvFileEncodingEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'CsvFileEncodingEnum'
		},

		// Structure Export
		// models
		{ dto: new ClsExportSetDTO(), tmo: new ExportSetTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new StructureExportClsFileTypeDTO(),
			tmo: ExportFileTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ExportFileTypeEnum'
		},
		{
			dto: new ClsExportSetDTOExportTypeEnum(),
			tmo: ExportSetTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ExportSetTypeEnum'
		},
		{
			dto: new ClsExportSetStatusDTO(),
			tmo: ExportSetStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ExportSetStatusEnum'
		},
		{
			dto: new ClsExportModeDTO(),
			tmo: ExportSetModeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ExportSetModeEnum'
		},

		// Managed Object
		// models
		{ dto: new ClsManagedObjectDTO(), tmo: new ManagedObjectTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums

		// NaturalPerson
		// models
		{ dto: new ClsNaturalPersonDTO(), tmo: new NaturalPersonTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsSalutationEnumDTO(),
			tmo: SalutationEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'SalutationEnum'
		},

		// Notification
		// models
		{ dto: new ClsAdminNotificationDTO(), tmo: new NotificationAdminTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsNotificationDTO(), tmo: new NotificationTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsNotificationTargetTypeDTO(),
			tmo: NotificationTargetTypeEnum,
			checkList: [ CheckEnum.ENUM_COMPARE_KEYS ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'NotificationTargetTypeEnum'
		},

		// Keyword
		// models
		{ dto: new ClsKeywordDTO(), tmo: new ArchivingKeywordTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums

		// OpenArchive
		// models
		{ dto: new ClsOpenArchiveDTO(), tmo: new OpenArchiveTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsArchivingFingerprintDTO(), tmo: new ArchivingFingerprintTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsOpenArchiveStatusDTO(),
			tmo: OpenArchiveStatusEnum,
			checkList: [ CheckEnum.ENUM_COMPARE_KEYS ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'OpenArchiveStatusEnum'
		},

		// OpenArchiveExport
		// models
		{ dto: new ClsOpenArchiveExportDTO(), tmo: new OpenArchiveExportTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsExportResultDTO(), tmo: new OpenArchiveExportResultTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsExportStatusEnumDTO(),
			tmo: OpenArchiveExportStatusEnum,
			checkList: [ CheckEnum.ENUM_COMPARE_KEYS ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'OpenArchiveExportStatusEnum'
		},

		// Organization
		// models
		{ dto: new ClsOrganizationDTO(), tmo: new OrganizationTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsLegalFormEnumDTO(),
			tmo: LegalFormEnum,
			checkList: [ CheckEnum.ENUM_COMPARE_KEYS ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'LegalFormEnum'
		},
		{
			dto: new ClsOrganizationStatusEnumDTO(),
			tmo: OrganizationStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'OrganizationStatusEnum'
		},

		// Outage
		// models
		{ dto: new ClsOutageEventDTO(), tmo: new OutageEventTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsEventReasonBodyDTO(), tmo: new OutageEventBodyTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{
			dto: new ClsBusinessPremisesCountDTO(),
			tmo: new TaskOutageBusinessPremisesCountTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		// enums
		{
			dto: new ClsEventStatusEnumDTO(),
			tmo: OutageEventStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'OutageEventStatusEnum'
		},

		// Resource lock
		// models
		{ dto: new ClsResourceLockDTO(), tmo: new ResourceLockTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsResourceLockTypeEnumDTO(),
			tmo: ResourceLockTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ResourceLockTypeEnum'
		},

		// Statistics
		// models
		{ dto: new ClsGlobalStatisticsDTO(), tmo: new GlobalStatisticTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsGlobalStatisticsResponseDTO(), tmo: new GlobalStatisticsTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsTenantStatisticsDTO(), tmo: new TenantStatisticsTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsEnvironmentEnumDTO(),
			tmo: GlobalStatisticEnvironmentEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'GlobalStatisticEnvironmentEnum'
		},

		// Taxation
		// models
		{ dto: new ClsRegistrationProtocolDTO(), tmo: new TaxationReportingTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{
			dto: new ClsRegistrationProtocolFailuresDTO(),
			tmo: new TaxationReportingFailuresTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{
			dto: new ClsMandateConfirmDTO(),
			tmo: new TaxationReportingMandateConfirmTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		// enums
		{
			dto: new ClsFormTypeEnumDTO(),
			tmo: TaxationReportingFormTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'TaxationReportingFormTypeEnum'
		},
		{
			dto: new ClsRegistrationProtocolStatusEnumDTO(),
			tmo: TaxationReportingStatusEnum,
			checkList: [ CheckEnum.ENUM_COMPARE_KEYS ],
			excludeTmoPropsFromCheckList: [ TaxationReportingStatusEnum.CREATING, TaxationReportingStatusEnum.SUBMITTING ],
			excludeDtoPropsFromCheckList: [ RegistrationProtocolStatusEnumDTO.CONFIRMED, RegistrationProtocolStatusEnumDTO.CREATED ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'TaxationReportingStatusEnum'
		},

		// Transactions
		// models
		{ dto: new ClsTransactionStatisticsDTO(), tmo: new TransactionStatisticsTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{
			dto: new ClsTransactionStatisticsTypeDTO(),
			tmo: new TransactionStatisticsTypeTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{
			dto: new ClsTransactionStatisticsTypeDetailDTO(),
			tmo: new TransactionStatisticsTypeDetailTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{
			dto: new ClsTransactionOperationCountDTO(),
			tmo: new TransactionOperationCountTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{
			dto: new ClsTenantTransactionStatisticsResponseDTO(),
			tmo: new TenantTransactionStatisticsTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		// enums

		// Tenant
		// models
		{ dto: new ClsTenantDTO(), tmo: new TenantTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsTenantBodyDTO(), tmo: new TenantFormBodyTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsContractLogDTO(), tmo: new TenantContractLogTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{
			dto: new ClsTenantTypeCountStatisticsDTO(),
			tmo: new TenantTypeCountStatisticsTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		// enums
		{
			dto: new ClsGlobalStatisticTenantTypeEnumDTO(),
			tmo: TenantTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'TenantTypeEnum'
		},

		// Tss
		// models
		{ dto: new ClsVirtualTssDTO(), tmo: new TssTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsExtVirtualTssDTO(), tmo: new TssExternalTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsVirtualTssBodyDTO(), tmo: new TssBodyTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsTssStatusGlobalStatisticsDTO(), tmo: new TssStatusStatisticsTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsTssModeGlobalStatisticsDTO(), tmo: new TssModeStatisticsTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsVirtualTssRequestDTO(), tmo: new TssRequestTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsVirtualTssVersionsCountResponseDTO(), tmo: new TssFccVersionsTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsVirtualTssPerFccVersionCountDTO(), tmo: new TssFccVersionsCountTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsModeCountDTO(), tmo: new TssFccVersionsModeCountTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsSubtypeModeCountDTO(), tmo: new TssFccVersionsSubtypeModeCountTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsVirtualTssDeviceTypeEnumDTO(),
			tmo: TssDeviceTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'TssDeviceTypeEnum',
			excludeDtoPropsFromCheckList: [ VirtualTssDeviceTypeEnumDTO.USD ],
			excludeTmoPropsFromCheckList: [ TssDeviceTypeEnum.MICRO_SD ]
		},
		{
			dto: new ClsVirtualTssStatusEnumDTO(),
			tmo: TssStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'TssStatusEnum'
		},
		{
			dto: new ClsExtVirtualTssStatusEnumDTO(),
			tmo: TssExternalStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'TssExternalStatusEnum'
		},
		{
			dto: new ClsVirtualTssModeEnumDTO(),
			tmo: TssModeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'TssModeEnum'
		},
		{
			dto: new ClsVirtualTssModeSubtypeEnumDTO(),
			tmo: TssModeSubTypeEnum,
			checkList: [ CheckEnum.ENUM_COMPARE_KEYS ],
			excludeTmoPropsFromCheckList: [ TssModeSubTypeEnum.NO_SUBTYPE ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'TssModeSubTypeEnum'
		},
		{
			dto: new ClsVirtualTssModeWithSubtypeEnumDTO(),
			tmo: TssModeWithSubTypeEnum,
			checkList: [ CheckEnum.ENUM_COMPARE_KEYS ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'TssModeWithSubTypeEnum'
		},
		{
			dto: new ClsAssignmentTypeEnumDTO(),
			tmo: TssAssignmentTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'TssAssignmentTypeEnum'
		},

		// TSS Pre-initialization
		// models
		{ dto: new ClsTssPreInitializationDTO(), tmo: new TssPreInitializationTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{
			dto: new ClsTssPreInitializationRequestDTO(),
			tmo: new TssPreInitializationRequestTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		// enums
		{
			dto: new ClsTssPreInitializationModeDTO(),
			tmo: TssPreInitializationModeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'TssPreInitializationModeEnum'
		},
		{
			dto: new ClsTssPreInitializationStatusDTO(),
			tmo: TssPreInitializationStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'TssPreInitializationStatusEnum'
		},

		// Usage - Archiving
		// models usage
		{ dto: new ClsContractUsageResponseDTO(), tmo: new ArchivingContractUsageTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsCustomerErsUsageDTO(), tmo: new ArchivingUsageTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{
			dto: new ClsErsActivatedPerMonthDTO(),
			tmo: new ArchivingUsageErsActivatedPerMonthTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{ dto: new ClsErsPriceDTO(), tmo: new ArchivingUsageErsPriceTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// models dataUsage
		{ dto: new ClsDataUsageDetailDTO(), tmo: new ArchivingDataUsageDetailTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsDataUsageDTO(), tmo: new ArchivingDataUsageTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsTenantDataUsageDTO(), tmo: new ArchivingTenantDataUsageTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{
			dto: new ClsContractDataUsageResponseDTO(),
			tmo: new ArchivingContractDataUsageTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		// enums

		// Usage - Fiskal
		// models
		{ dto: new ClsUsageDTO(), tmo: new UsageTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{
			dto: new ClsBusinessPremisesUsageContractDTO(),
			tmo: new BusinessPremisesUsageTMO(),
			checkList: [ CheckEnum.MODEL_CHECK_ALL ],
			type: ObjectTypeEnum.CLASS
		},
		{ dto: new ClsTenantUsageContractDTO(), tmo: new TenantUsageTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsOrganizationUsageContractDTO(), tmo: new OrganizationUsageTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsUsageItemDTO(), tmo: new UsageItemTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsCustomerUsageContractDTO(), tmo: new ContractUsageTenantsTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsErsUsageDTO(), tmo: new ErsUsageTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsErsUsageItemDTO(), tmo: new ErsUsageItemTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsVirtualTssUsageDTO(), tmo: new TssUsageTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsVirtualTssUsageItemDTO(), tmo: new TssUsageItemTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsReportStatusDTO(), tmo: new ReportStatusTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{
			dto: new ClsUsageTypeEnumDTO(),
			tmo: UsageItemFullTypeEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'UsageItemFullTypeEnum'
		},
		{
			dto: new ClsReportStatusEnumDTO(),
			tmo: ReportStatusEnum,
			checkList: [ CheckEnum.ENUM_CHECK_ALL ],
			type: ObjectTypeEnum.ENUM,
			tmoEnumName: 'ReportStatusEnum'
		},

		// User
		// models
		{ dto: new ClsUserDTO(), tmo: new UserTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsUserBodyDTO(), tmo: new UserUpdateBodyTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsCreateUserBodyDTO(), tmo: new UserCreateBodyTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsUserStatusBodyDTO(), tmo: new UserStatusBodyTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		{ dto: new ClsUserPasswordChangeBodyDTO(), tmo: new UserChangePassTMO(), checkList: [ CheckEnum.MODEL_CHECK_ALL ], type: ObjectTypeEnum.CLASS },
		// enums
		{ dto: new ClsUserStatusDTO(), tmo: UserStatusEnum, checkList: [ CheckEnum.ENUM_CHECK_ALL ], type: ObjectTypeEnum.ENUM, tmoEnumName: 'UserStatusEnum' },
		{ dto: new ClsRealmDTO(), tmo: RealmEnum, checkList: [ CheckEnum.ENUM_CHECK_ALL ], type: ObjectTypeEnum.ENUM, tmoEnumName: 'RealmEnum' }
	]
};
